import classNames from 'classnames'
import React from 'react'
import {
  MaterialIcon,
  MaterialIconRef,
} from 'src/components/framework/icons/material-icon'
import { useFeaturesContext } from 'src/contexts/features.context'
import { useSecurityContext } from 'src/contexts/security.context'
import { Colors } from 'src/shared/colors'
import { StockRanksData } from 'src/shared/stock-ranks'

import * as styles from './stock-ranks.module.scss'

export const StockRanks: React.FC = () => {
  const {
    features: { ranks },
  } = useFeaturesContext()
  const { security } = useSecurityContext()

  const data = RANK_DATA.map((row) => ({
    ...row,
    value: security.ranks[row.id],
    enabled: ranks[row.id],
  }))

  return (
    <ul className={classNames(styles.stockRanks, 'enhance-colors')}>
      {data.map((item, index) => (
        <li
          key={index}
          className={classNames(styles.stockRanks__row, {
            [styles.stockRanks__rowPrimary]: item.primary,
          })}
        >
          <div className={styles.stockRanks__column}>
            <a href={item.href}>{item.label}</a>
          </div>
          <div>
            {item.enabled ? (
              <span
                className={classNames(
                  'stk-lotto',
                  'stk-lotto--large',
                  'stk-space-in-0',
                  getStockRankColor(item.value),
                )}
              >
                {item.value === null ? '—' : item.value}
              </span>
            ) : (
              <span
                className={
                  'stk-lotto stk-lotto--neutral stk-lotto--large stk-space-in-0'
                }
              >
                <MaterialIcon
                  icon={MaterialIconRef.Locker}
                  size={12}
                  color={Colors.White}
                />
              </span>
            )}
          </div>
        </li>
      ))}
    </ul>
  )
}

interface RankData {
  id: keyof StockRanksData
  label: string
  href: string
  value: number | null
  enabled: boolean
  primary?: boolean
}

const STOCK_RANKS_GUIDE_URL =
  'https://help.stockopedia.com/product-guide/stockranks/basics/'

const RANK_DATA: ReadonlyArray<RankData> = [
  {
    id: 'quality',
    label: 'Quality',
    href: `${STOCK_RANKS_GUIDE_URL}/the-quality-rank`,
    value: null,
    enabled: false,
  },
  {
    id: 'value',
    label: 'Value',
    href: `${STOCK_RANKS_GUIDE_URL}/the-value-rank`,
    value: null,
    enabled: false,
  },
  {
    id: 'momentum',
    label: 'Momentum',
    href: `${STOCK_RANKS_GUIDE_URL}/the-momentum-rank`,
    value: null,
    enabled: false,
  },
  {
    id: 'stockRank',
    label: 'StockRank™',
    href: `${STOCK_RANKS_GUIDE_URL}/the-stockrank`,
    primary: true,
    value: null,
    enabled: false,
  },
]

function getStockRankColor(value: number | null): string {
  let color: string

  if (value === null) {
    color = 'neutral'
  } else if (value < 20) {
    color = 'sucker-red'
  } else if (value < 80) {
    color = 'neutral'
  } else if (value < 90) {
    color = 'strong-green'
  } else {
    color = 'super-green'
  }

  return `stk-lotto--${color}`
}
